/**
* Endpoint methods related to Stripe API 
*/
import API from "./Api";

const skKey = process.env.VUE_APP_STRIPE_SECRET_KEY;

export default {
    /**
    * Gets the product data by Product Id
    */
    async getProductByProdyctId(productId) {
        return API.get("https://api.stripe.com/v1/products/" + productId, {
            headers: {
                Authorization: 'Bearer ' + skKey,
            }
        });
    },

    /**
    * Gets the product price by Product Id
    */
    async getProductPricesByProdyctId(priceId) {
        return API.get("https://api.stripe.com/v1/prices/" + priceId, {
            headers: {
                Authorization: 'Bearer ' + skKey,
            }
        });
    },

    /**
    * Creates a Stripe customer
    */
    async createCustomer(params) {

        const parameters = new URLSearchParams();

        for (const [key, value] of Object.entries(params)) {
            parameters.append(key, value);
        }

        return API.post("https://api.stripe.com/v1/customers",
            parameters,
            {
                headers: {
                    Authorization: 'Bearer ' + skKey,
                    'content-type': 'application/x-www-form-urlencoded',
                }
            });

    },

    /**
    * Creates a Stripe Connected Account Customer
    */
    async createConnectedAccountCustomer(params) {

        const parameters = new URLSearchParams();

        for (const [key, value] of Object.entries(params)) {
            if (key != "stripe_account"){
                parameters.append(key, value);
            }
        }

        return API.post("https://api.stripe.com/v1/customers",
            parameters,
            {
                headers: {
                    Authorization: 'Bearer ' + skKey,
                    'content-type': 'application/x-www-form-urlencoded',
                    "Stripe-Account": params.stripe_account
                }
            });

    },

    /**
    * Creates a Stripe Subscription
    */
    async createSubscription(params) {

        const parameters = new URLSearchParams();

        for (const [key, value] of Object.entries(params)) {
            parameters.append(key, value);
        }

        return API.post("https://api.stripe.com/v1/subscriptions",
            parameters,
            {
                headers: {
                    Authorization: 'Bearer ' + skKey,
                    'content-type': 'application/x-www-form-urlencoded',
                }
            });
    },

    /**
    * Creates a Stripe Payment Method
    */
    async getStripePaymentMethods(params) {

        const parameters = new URLSearchParams();

        for (const [key, value] of Object.entries(params)) {
            parameters.append(key, value);
        }

        return API.get("https://api.stripe.com/v1/payment_methods",
            {
                headers: {
                    Authorization: 'Bearer ' + skKey,
                }
            });
    },

    /**
    * Attaches the Payment Method to the Customer
    */
    async attachPaymentMethodToCustomer(params, paymentMetod) {

        const parameters = new URLSearchParams();

        for (const [key, value] of Object.entries(params)) {
            parameters.append(key, value);
        }

        return API.post("https://api.stripe.com/v1/payment_methods/" + paymentMetod + "/attach",
            parameters,
            {
                headers: {
                    Authorization: 'Bearer ' + skKey,
                    'content-type': 'application/x-www-form-urlencoded',
                }
            });
    },

    /**
    * Sens a Stripe Invoice for Payment
    */
    async sendStripeInvoiceForPayment(invoiceId) {
        const parameters = new URLSearchParams();
        return API.post("https://api.stripe.com/v1/invoices/" + invoiceId + "/send",
            parameters,
            {
                headers: {
                    Authorization: 'Bearer ' + skKey,
                    'content-type': 'application/x-www-form-urlencoded',
                }
            });
    },

    /**
    * Creates a Stripe Checkout Session
    */
    async getStripeCheckoutSession(payload) {
        let headers = {
            Authorization: 'Bearer ' + skKey,
        }
        if (payload.connectedAccount){
            headers["Stripe-Account"] = payload.connectedAccount;
        }
        return API.get("https://api.stripe.com/v1/checkout/sessions/" + payload.id, {
            headers: headers
        });
    },

    /**
    * Gets a Stripe Subscription by ID
    */
    async getStripeSubscriptionById(subscriptionId) {

        return API.get("https://api.stripe.com/v1/subscriptions/" + subscriptionId, {
            headers: {
                Authorization: 'Bearer ' + skKey,
            }
        });

    },

    /**
    * Creates a Stripe Coupon
    */
    async createCoupon(params) {

        const parameters = new URLSearchParams();

        for (const [key, value] of Object.entries(params)) {
            parameters.append(key, value);
        }

        return API.post("https://api.stripe.com/v1/coupons",
            parameters,
            {
                headers: {
                    Authorization: 'Bearer ' + skKey,
                    'content-type': 'application/x-www-form-urlencoded',
                }
            });
    },
    
    /**
    * Creates an Invoice Item in the Stripe Invoice
    */
    async createStripeInvoiceItem(params){
        const parameters = new URLSearchParams();

        for (const [key, value] of Object.entries(params)) {
            if (key != "StripeAccount"){
                parameters.append(key, value);
            }
        }

        return API.post("https://api.stripe.com/v1/invoiceitems",
            parameters,
            {
                headers: {
                    Authorization: 'Bearer ' + skKey,
                    'content-type': 'application/x-www-form-urlencoded',
                    'Stripe-Account': params.StripeAccount
                }
            });
    },

    /**
    * Creates a Stripe Invoice
    */
    async createStripeInvoice(params){
        const parameters = new URLSearchParams();

        for (const [key, value] of Object.entries(params)) {
            if (key != "StripeAccount"){
                parameters.append(key, value);
            }
        }

        return API.post("https://api.stripe.com/v1/invoices",
            parameters,
            {
                headers: {
                    Authorization: 'Bearer ' + skKey,
                    'content-type': 'application/x-www-form-urlencoded',
                    'Stripe-Account': params.StripeAccount
                }
            });
    },

    /**
    * Gets the Stripe Payment Intent Data
    */
    async getPaymentIntent(payload){
        return API.get("https://api.stripe.com/v1/payment_intents/" + payload.id, {
            headers: {
                Authorization: 'Bearer ' + skKey,
                "Stripe-Account": payload.StripeAccount
            }
        });
    }

};